<script setup>
import { watch, ref, inject, computed, onMounted } from 'vue';
import { initializeApp } from "firebase/app";
import { getDatabase, ref as dbRef, onValue, set, push, query, orderByChild, remove, update, orderByKey } from "firebase/database";
import { useDatabaseList, useDatabaseObject, useDocument } from 'vuefire'
import { onAuthStateChanged, getAuth } from "firebase/auth";
import draggable from 'vuedraggable'
import { ListBulletIcon } from '@heroicons/vue/20/solid';
const firebaseConfig = inject('firebaseConfig')
const firebase_dbpath = inject('firebase_dbpath')

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);
const db_ref = dbRef(db, 'todos');
const todos = useDatabaseList(db_ref)
const drag = ref(false)

const todos2 = useDocument(dbRef(db, 'todos'))
const sortedItems = ref(todos2);


watch(todos, (val) => {
        const list = val.slice();
        const res = list.sort((a, b) => (a.sort > b.sort) ? 1 : 0)
        sortedItems.value = res
})



const pushdata = () => {

    let i = 0;
    const transformedObject = sortedItems.value.reduce((obj, item) => {
        const { id, ...rest } = item;

        obj[id] = rest;
        obj[id].date = Date.now()
        obj[id].sort = i++
        return obj;
    }, {});

    set(db_ref,
        transformedObject
    )

    return true
}



</script>

<template>
    <div class="bg-white">
        <!-- <ul>
        <li v-for="todo in todos2" :key="todo.id" class="p-2 cursor-move">
            <span>{{ todo.text }}</span>
        </li>
    </ul>  -->
        <draggable v-model="todos2" @start="drag = true" @end="pushdata" item-key="id" handle=".handle">
            <template #item="{ element }">
                <div class="p-2 bg-secondary-600 m-1">{{ element.title }} {{ element.sort }} <ListBulletIcon class="h-8 w-8 handle cursor-move" /></div>
            </template>
        </draggable>

        <div v-for="item in sortedItems" :key="item.id">{{ item.title }} {{ item.sort }}</div>
    </div>
</template>